import configureStore from './configureStore.dev';
export default configureStore();